import { render, staticRenderFns } from "./BuildingStoreys.vue?vue&type=template&id=fb488520&scoped=true&"
import script from "./BuildingStoreys.vue?vue&type=script&lang=js&"
export * from "./BuildingStoreys.vue?vue&type=script&lang=js&"
import style0 from "./BuildingStoreys.vue?vue&type=style&index=0&id=fb488520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb488520",
  null
  
)

export default component.exports